export { Caption } from '@sberdevices/plasma-core';
